import axiosInstance from 'services/axiosInstance';
import { IResponse } from 'services/types';
import {
  ICreateWhatsAppChatPayload,
  ICreateWhatsAppChatResponse,
  ISendWhatsAppMessagePayload,
  IWhatsAppChat,
  IWhatsAppMessage,
  IWhatsAppSettings,
} from 'services/whatsAppMessaging/types';

const baseUrl = '/WhatsAppMessaging';

/** GET /WhatsAppSettings - returns settings when WhatsApp is configured */
export const getWhatsAppSettings = (): IResponse<IWhatsAppSettings> =>
  axiosInstance.request({
    method: 'GET',
    url: '/WhatsAppSettings',
  });

/** GET /WhatsAppMessaging/crm/{crmId}/contact/{contactId} - get chat for contact */
export const getWhatsAppChatByContact = (
  crmId: number,
  contactId: string,
): IResponse<IWhatsAppChat> =>
  axiosInstance.request({
    method: 'GET',
    url: `${baseUrl}/crm/${crmId}/contact/${contactId}`,
  });

export const createWhatsAppChat = (
  payload: ICreateWhatsAppChatPayload,
): IResponse<ICreateWhatsAppChatResponse> =>
  axiosInstance.request({
    method: 'POST',
    url: `${baseUrl}/chats`,
    data: payload,
  });

export const getWhatsAppChatMessages = (chatId: string): IResponse<IWhatsAppMessage[]> =>
  axiosInstance.request({
    method: 'GET',
    url: `${baseUrl}/chats/${chatId}/messages`,
  });

export const getWhatsAppChat = (chatId: string): IResponse<IWhatsAppChat> =>
  axiosInstance.request({
    method: 'GET',
    url: `${baseUrl}/chats/${chatId}`,
  });

export const sendWhatsAppMessage = (
  chatId: string,
  payload: ISendWhatsAppMessagePayload,
): IResponse<IWhatsAppMessage> =>
  axiosInstance.request({
    method: 'POST',
    url: `${baseUrl}/chats/${chatId}/messages`,
    data: payload,
  });

/** POST /WhatsAppMessaging/chats/{chatId}/messages/attachment - send media (photo, video, document) */
export const sendWhatsAppAttachment = (
  chatId: string,
  file: FormData,
  fileType: string,
): IResponse<IWhatsAppMessage> =>
  axiosInstance.post(`${baseUrl}/chats/${chatId}/messages/attachment`, file, {
    headers: {
      'Content-Type': fileType,
    },
  });

/** DELETE /WhatsAppMessaging/chats/{id} - delete WhatsApp chat */
export const deleteWhatsAppChat = (chatId: string): IResponse<void> =>
  axiosInstance.request({
    method: 'DELETE',
    url: `${baseUrl}/chats/${chatId}`,
  });
